/**
 * Component: PDP Showroom display
 *
 * Liquid already renders a valid state — the first code in Displayed At — so this only swaps it
 * when the shopper's location points at a showroom this product is actually on display at, and
 * swaps it back when it stops doing so. Nothing is written back and the list is never reordered:
 * choosing a location belongs to the header selector.
 */
(() => {
  const LABEL = "[showroom display]";
  const CURRENT_SELECTOR = "[data-showroom-current]";
  const ITEM_SELECTOR = "[data-showroom-id]";
  const CURRENT_STATE_CLASS = "_current";

  const locationState = window.HudsonLocation;

  class ProductShowroomDisplay extends HTMLElement {
    connectedCallback() {
      if (!locationState) {
        console.error(`${LABEL} hudson-location.js did not load, the list keeps its Liquid state.`);
        return;
      }

      this.defaultItem = this.querySelector(`.${CURRENT_STATE_CLASS}`);
      this.listeners = new AbortController();

      document.addEventListener(
        locationState.EVENT,
        (event) => this.apply(event.detail.location?.showroomId),
        { signal: this.listeners.signal },
      );

      this.apply(locationState.getShowroomId());
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    apply(showroomId) {
      const items = Array.from(this.querySelectorAll(ITEM_SELECTOR));
      const activeItem =
        items.find((item) => item.dataset.showroomId === showroomId) || this.defaultItem;
      if (!activeItem) return;

      this.querySelector(`.${CURRENT_STATE_CLASS}`)?.classList.remove(CURRENT_STATE_CLASS);
      activeItem.classList.add(CURRENT_STATE_CLASS);

      const currentName = this.querySelector(CURRENT_SELECTOR);
      if (currentName) currentName.textContent = activeItem.dataset.showroomName;
    }
  }

  if (!customElements.get("product-showroom-display")) {
    customElements.define("product-showroom-display", ProductShowroomDisplay);
  }
})();
